export const clearInputs = (element, targetName) => {
  const targetElement = targetName ? element[targetName] : element;

  if (targetElement) {
    targetElement.querySelectorAll('input, textarea, select').forEach(el => {
      if (el.tagName === 'INPUT') {
        // radios are a subset of el.tagName === 'INPUT'
        if (el.type === 'radio') {
          // do not clear values for radiobuttons
          return;
        } else if (el.type === 'checkbox') {
          // For checkboxes, only clear the checked state, not the value attribute
          el.checked = false;
        } else {
          el.value = "";
        }
      } else {
        el.value = "";
      }
    });
  }
};

export const populateSelectOptions = (selectInput, collection) => {
  selectInput.innerHTML = '';
  
  Object.entries(collection).forEach(([label, value]) => {
    const optionElement = document.createElement("option");
    optionElement.value = value;
    optionElement.text = label;
    selectInput.appendChild(optionElement);
  });
};

// sometimes it's not feasible to use visibility controller, #show and #hide, or #toggleVisibility provide easy access to the "same" functionality
export const show = (elem) => {
  elem.removeAttribute("hidden");
};

export const hide = (elem, shouldClearInputs = true) => {
  elem.setAttribute("hidden", true);
  if (shouldClearInputs) clearInputs(elem);
};

export const toggleVisibility = (element, shouldShow, shouldClearInputs = true) => {
  if (shouldShow) {
    show(element);
  } else {
    hide(element, shouldClearInputs);
  }
};
